import { Ability } from '@casl/ability'
// import _ from 'lodash';

export default new Ability([])

// function subjectName(item) {
//   if (!item || typeof item === 'string') {
//     return item
//   }
//   console.deug('Type is:  ', item.__type);
//   return item.__type
// }

// export default AbilityBuilder.define({ subjectName }, (can, cannot) => {

//   const role = localStorage.getItem('_roles');
//   const adminroles =  (_.includes(role, 'merchant') || _.includes(role, 'admin')) ? true : false;

//   if(adminroles){
//     can('view', '/technicalService')
//     can('view', '/transaction')
//     can('view', '/account')
//     can('view', '/account/profile')
//     can('view', '/account/intigration')
//   }else{
//     can('view', '/account')
//     can('view', '/transaction')
//     can('view', '/account/profile')
//   }

// })